import { render, staticRenderFns } from "./Receivers.vue?vue&type=template&id=28364159&scoped=true&"
import script from "./Receivers.vue?vue&type=script&lang=ts&"
export * from "./Receivers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28364159",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
installComponents(component, {VOtpInput})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28364159')) {
      api.createRecord('28364159', component.options)
    } else {
      api.reload('28364159', component.options)
    }
    module.hot.accept("./Receivers.vue?vue&type=template&id=28364159&scoped=true&", function () {
      api.rerender('28364159', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Receivers.vue"
export default component.exports